import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent {
  constructor(private router:Router, private authService: AuthService) {}

  ngOnInit() {
    if (!localStorage.getItem('isWelcome')) {
      this.router.navigate(['/sign-up']);
    }
    localStorage.removeItem('isWelcome');
    this.authService.checkAuthAndRedirectHome();
  }
  redirectLogin(){
    this.router.navigateByUrl('/log-in');
  }
}
